// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"268":"Home","362":"Dashboard"}[chunkId] || chunkId) + "." + {"60":"1b3b84d5","174":"33d0042f","268":"d6e6c61c","362":"fd75b060","393":"57192f99"}[chunkId] + ".js";
};